// extracted by mini-css-extract-plugin
module.exports = {"item":"menu-item_item__O_CDI","itemLink":"menu-item_itemLink__kcxfS","itemLink--active":"menu-item_itemLink--active__luVgW","itemIcon":"menu-item_itemIcon__nUE6l"};